import React from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import PaymentMethodSetup from "components/payment/PaymentMethodSetup/PaymentMethodSetup";
import type { ReservationPaymentSetupAdapter } from "pages/new/hooks/useReservationPaymentSetup";
import LinkPaymentMethod from "components/globals/LinkPaymentMethod";
import { isLinkPaymentMethod } from "globals/utils/paymentMethods";

export const ReservationPaymentForm = ({
  checkout,
  isSubmitting,
}: {
  checkout: ReservationPaymentSetupAdapter;
  isSubmitting?: boolean;
}) => {
  const { state } = checkout;
  if (!state) return null;
  if (state.addCardReturn)
    return (
      <Typography>
        Complete the Add Card dialog, then select Reserve to continue.
      </Typography>
    );
  return (
    <Box mb={4}>
      {state.result && (
        <Box>
          <Typography>
            {isLinkPaymentMethod(state.result) ? (
              <LinkPaymentMethod />
            ) : (
              `Card ending in ${state.result.card.last4}`
            )}{" "}
            is ready. Select Reserve to continue.
          </Typography>
          <Button
            disabled={isSubmitting}
            onClick={() => checkout.restart(true)}
          >
            Use a different card
          </Button>
        </Box>
      )}
      {!state.result && (
        <PaymentMethodSetup
          ref={checkout.elementRef}
          operatorId={checkout.operatorId}
          currency={checkout.currency}
          savedPaymentMethods={checkout.savedPaymentMethods}
          canSaveForFutureBookings={checkout.isAuthenticated}
          attemptScope={state.ownerKey}
          context={{
            surface: "reservation",
            payerId: checkout.isAuthenticated ? checkout.payerId : undefined,
            checkoutContext: state.checkoutContext,
          }}
          attemptKey={state.attemptKey}
          initialAttempt={state.attempt}
          resume={state.resume}
          onAttemptCreated={checkout.onAttemptCreated}
          onBeforeConfirm={checkout.onBeforeConfirm}
          billingDetails={{
            email: checkout.billingEmail,
          }}
          returnUrl={window.location.pathname}
          onStateChange={checkout.onStateChange}
        />
      )}
      {checkout.error && checkout.error !== checkout.setupState?.error && (
        <Alert severity="error">{checkout.error}</Alert>
      )}
      {state.resume && !state.result && !checkout.setupState?.error && (
        <Typography>
          Your card verification has returned. Select Reserve to check and
          continue.
        </Typography>
      )}
      {(checkout.setupState?.restartRequired ||
        checkout.error?.includes("Restart card setup")) && (
        <Button disabled={isSubmitting} onClick={() => checkout.restart()}>
          Restart card setup
        </Button>
      )}
    </Box>
  );
};
